/**
 * @typedef { import('../PaymentGroupModel').PaymentGroupModel } PaymentGroupModel
 */

import { TromanError } from '../../../common/TromanError';

export class GroupDialogResult {
    /**
     * 
     * @param {PaymentGroupModel} paymentGroup 
     */
    apply(_paymentGroup) {
    }
}

export class RemunerationDeletedResult extends GroupDialogResult {
    constructor(remunerationId) {
        super();
        if (!remunerationId) throw new TromanError('missing_remuneration_id');
        this.remunerationId = remunerationId;
    }

    /**
     * 
     * @param {PaymentGroupModel} paymentGroup 
     */
    apply(paymentGroup) {
        paymentGroup.payslipModel.remunerationDeleted(paymentGroup);
    }
}

export class CertificationRecalledResult extends GroupDialogResult {
    constructor(newRemuneration) {
        super();
        if (!newRemuneration) throw new TromanError('missing_new_remuneration');
        this.newRemuneration = newRemuneration;
    }

    /**
     * 
     * @param {PaymentGroupModel} paymentGroup 
     */
    apply(paymentGroup) {
        paymentGroup.payslipModel.certificationRecalled(paymentGroup, this.newRemuneration);
    }
}

export class ClaimRecalledResult extends GroupDialogResult {
    constructor(newClaim) {
        super();
        if (!newClaim) throw new TromanError('missing_new_claim');
        this.newClaim = newClaim;
    }

    /**
     * 
     * @param {PaymentGroupModel} paymentGroup 
     */
    apply(paymentGroup) {
        paymentGroup.payslipModel.claimRecalled(paymentGroup, this.newClaim);
    }
}
